<template>
    <div class="groupField">
        <div class="groupFieldTitle">
            <span>Subcompanies</span>
            <button v-if="subcompanies_type && !subcompanies_status" type="button" @click="onAddItem">
                <svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
            </button>
        </div>
        <div v-if="subcompanies_status" class="warning_block">
            <svg-sprite width="20" height="20" icon-id="warning"></svg-sprite>
            <span>Is already a subcompany for “{{ subcompanies_name }}”</span>
        </div>
        <div v-else>
            <div class="switch">
                <v-switch
                    class="switch"
                    :input-value="subcompanies_type"
                    label="Subcompanies"
                    color="success"
                    hide-details
                    dense
                    @change="onSwitch($event)"
                ></v-switch>
            </div>
            <template v-if="subcompanies_type">
                <template v-for="(item, idx) in subcompanies">
                    <div class="groupField_wrap" :key="idx">
                        <field
                            :classError="getError(idx)"
                            margin="0 0 10px 0"
                            width="255px"
                            label="Customer"
                            placeholder="Select customer"
                            @updateAutocomplete="onAutocomplete($event)"
                            :autocompleteValue="item"
                            :items="select_companies_list"
                            :idx="idx"
                            :isClearable="false"
                            is-required
                            is-autocomplete
                        ></field>
                        <button v-if="subcompanies.length !== 1" type="button" class="deleteItem" @click="onDeleteItem(idx)">
                            <svg-sprite style="color: #19BC38" width="20" height="20" icon-id="deleteItem"></svg-sprite>
                        </button>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
export default {
	name: "CustomerList",
	props: {
		valid: Object,
		subcompanies: Array,
		select_companies_list: Array,
		subcompanies_type: Boolean,
		subcompanies_name: String,
		subcompanies_status: Boolean,
	},
	methods: {
		getError(idx) {
			return this.valid.subcompanies?.$each?.$iter[idx]?.id?.$error;
		},
		onAddItem() {
			const value = {
				sub_id: null
			};

			this.$emit('updateSubcompaniesList', { item: value });
		},
		onAutocomplete({ value, idx }) {
			let item = this.subcompanies.find((item, index) => index === idx);
			if (item) {
				item = { ...item, ...value };
			} else {
				item = value;
			}

			this.$emit('updateSubcompaniesList', { item, idx });
		},
		onDeleteItem(idx) {
			this.$emit('updateSubcompaniesDelete', idx);
		},
		onSwitch(value) {
			if (value) {
				this.subcompaniesList = this.subcompanies;
			}
			this.$emit('updateSubcompaniesType', value);
		}
	}
};
</script>

<style scoped lang="scss">

</style>
